<template lang="pug">
.filter-field-widget
  .filter-field-widget-header
    select.colorpicker-filter-field-alt(v-model="filterSelectedValue")
      option(v-for="filterValue in hookedFilterValues" :value="filterValue.value" v-text="filterValue.label")
    a.compare-fabrics-link.doc-link.scrollAnchor(href="#compare_fabrics_tamisant" :target="_blank" v-text="frText.abTest.prd14.variationB.fields.colorFilter.compareMaterialLink")
  .filter-field-widget-tags
    .filter-field-widget-tag(v-for="taggedFilter in taggedFilters" v-text="taggedFilter.label" v-on:click="removeTag(taggedFilter.value)")

</template>
<script>
import fr from '../../../config/translationFr'
export default {
  name: 'filter-field-widget',
  props: {
    field: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      filterSelectedValue: 'all',
      taggedFilters: []
    }
  },
  created: function () {
  },
  components: {
    // Dimension
  },
  computed: {
    frText: function () {
      return fr
    },
    hookedFilterValues: function () {
      return this.hookFilter(this.field).hookedValues
    }
  },
  methods: {
    removeTag: function (tagValue) {
      this.taggedFilters = this.taggedFilters.reduce((reduced, tag) => {
        if (tag.value !== tagValue) {
          reduced.push(tag)
        }
        return reduced
      }, [])
    },
    hookFilter: function (field) {
      field.hookedValues = {
        all: {
          label: 'FILTRER PAR COULEURS',
          value: 'all',
          relatedFilterValues: [
            'VALFIL-37_blanc',
            'VALFIL-38_beige',
            'VALFIL-39_marron',
            'VALFIL-40_noir',
            'VALFIL-41_gris',
            'VALFIL-43_rouge',
            'VALFIL-44_rose-violet',
            'VALFIL-46_jaune',
            'VALFIL-45_orange',
            'VALFIL-42_bleu',
            'VALFIL-61_vert'
          ]
        },
        white: {
          label: 'Blanc',
          value: 'white',
          relatedFilterValues: ['VALFIL-37_blanc']
        },
        beigeBrown: {
          label: 'Beige - Marron',
          value: 'beigeBrown',
          relatedFilterValues: ['VALFIL-38_beige', 'VALFIL-39_marron']
        },
        greyBlack: {
          label: 'Gris - Noir',
          value: 'greyBlack',
          relatedFilterValues: ['VALFIL-40_noir', 'VALFIL-41_gris']
        },
        redPinkPurple: {
          label: 'Rouge - Rose - Violet',
          value: 'redPinkPurple',
          relatedFilterValues: ['VALFIL-43_rouge', 'VALFIL-44_rose-violet']
        },
        yellowOrange: {
          label: 'Jaune / Orange',
          value: 'yellowOrange',
          relatedFilterValues: ['VALFIL-46_jaune', 'VALFIL-45_orange']
        },
        blueGreen: {
          label: 'Bleu / Vert',
          value: 'blueGreen',
          relatedFilterValues: ['VALFIL-42_bleu', 'VALFIL-61_vert']
        }
      }
      return field
    }
  },
  watch: {
    filterSelectedValue: function (newValue, oldValue) {
      if (this.taggedFilters.length === 0) {
        if (newValue !== 'all') {
          this.taggedFilters.push(this.hookFilter(this.field).hookedValues[newValue])
        }
      } else if (!(this.taggedFilters.find(filterValue => filterValue.value === newValue || newValue === 'all'))) {
        this.taggedFilters.push(this.hookFilter(this.field).hookedValues[newValue])
      }
    },
    taggedFilters: function (newValue, oldValue) {
      let filtersValue = newValue.reduce((reduced, tag) => {
        reduced = [...reduced, ...tag.relatedFilterValues]
        return reduced
      }, [])
      if (filtersValue.length === 0) {
        filtersValue = this.hookFilter(this.field).hookedValues.all.relatedFilterValues
      }
      this.$emit('change-color-filter-values', {
        [this.field.chKey]: {
          newValue: filtersValue
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// FilterFieldWidget.vue?62691ade